export enum RateUnit {
  HOUR = 'HOUR',
  VISIT = 'VISIT',
  NIGHT = 'NIGHT'
}

export enum OverrideLevel {
  BASE = 'BASE',
  SHIFT_TYPE = 'SHIFT_TYPE',
  VISIT_TYPE = 'VISIT_TYPE'
}

export interface RateOverride {
  eventTypeId: string | null
  level: OverrideLevel
  rate: string
}

export interface InvoicingRateCard {
  _id: string
  homeId: string
  name: string
  baseRate: string
  currency: string
  unit: RateUnit
  overrides: RateOverride[]
  effectiveDate: string | null
  locked: boolean
  supersededAt: string | null
  previousVersionId: string | null
  initialId: string
  deleted: boolean
  deletedAt: string | null
  createdAt: string
  updatedAt: string
  createdBy: string
  updatedBy: string
}

export enum FunderContractType {
  NHS = 'NHS',
  LOCAL_AUTHORITY = 'LOCAL_AUTHORITY',
  INSURANCE = 'INSURANCE',
  SUBSIDISED = 'SUBSIDISED',
  PRIVATE = 'PRIVATE',
  OTHER = 'OTHER'
}

export interface FunderAddress {
  buildingName?: string
  line1?: string
  line2?: string
  city?: string
  country?: string
  postcode?: string
}

export interface FunderContract {
  _id: string
  name: string
  invoicingRateCardInitialId: string
  notes?: string
  deleted: boolean
}

export interface Funder {
  _id: string
  homeId: string
  name: string
  contractType: FunderContractType
  address: FunderAddress
  email?: string
  externalFundingTypeId?: string
  isPrivate: boolean
  externalContactId?: string
  contracts: FunderContract[]
  deleted: boolean
  createdAt: string
  updatedAt: string
  createdBy: string
  updatedBy: string
}

// ---- Phase 2: Resident Funding ----

export interface ResidentFunding {
  _id: string
  homeId: string
  residentId: string
  funderId: string
  contractId?: string | null
  hoursPerWeek: number
  effectiveFrom: string
  effectiveTo?: string | null
  notes?: string | null
  deleted: boolean
  createdAt: string
  updatedAt: string
}

export interface ResidentFundingView extends ResidentFunding {
  funder?: Funder
  contract?: FunderContract
}

export interface CreateResidentFundingDto {
  residentId: string
  funderId: string
  contractId?: string
  hoursPerWeek: number
  effectiveFrom: string
  effectiveTo?: string
  notes?: string
}

export type UpdateResidentFundingDto = Partial<CreateResidentFundingDto>

export interface CreateFunderFromContactDto {
  name: string
  externalContactId: string
  email?: string
}
